<template>
  <!-- <div class="md-layout"> -->
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>person</md-icon>
      </div>
      <h4 class="title">
        Rider Details
      </h4>
    </md-card-header>
    <md-card-content>
      <form>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="title">Title</label>
              <md-select v-model="customer.title" name="title" id="title">
                <md-option value="Mr">Mr</md-option>
                <md-option value="Mrs">Mrs</md-option>
                <md-option value="Miss">Miss</md-option>
                <md-option value="Ms">Ms</md-option>
                <md-option value="Dr">Dr</md-option>
                <md-option value="Prof">Prof</md-option>
                <md-option value="Rev">Rev</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-40">
            <md-field>
              <label>First Name</label>
              <md-input v-model="customer.first_name" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-40">
            <md-field>
              <label>Last Name</label>
              <md-input v-model="customer.last_name" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Email Address</label>
              <md-input v-model="customer.email" type="email"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Phone</label>
              <md-input v-model="customer.tel_num" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Mobile</label>
              <md-input v-model="customer.cell_num" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Address</label>
              <md-input v-model="customer.address_1" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Address</label>
              <md-input v-model="customer.address_2" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>City</label>
              <md-input v-model="customer.city" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>County/State</label>
              <md-input v-model="customer.county" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label for="country">Country</label>
              <md-select v-model="customer.country" name="country" id="country">
                <md-option
                  v-for="country in countries"
                  :key="country"
                  :value="country"
                >
                  {{ country }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Postcode</label>
              <md-input v-model="customer.postcode" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label for="gender">Gender</label>
              <md-select v-model="customer.gender" name="gender" id="gender">
                <md-option value="Male">Male</md-option>
                <md-option value="Female">Female</md-option>
                <md-option value="NonBinary">Non-Binary</md-option>
                <md-option value="Other">Other</md-option>
                <md-option value="PreferNotToSay">Prefer not to say</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-datepicker
              v-model="customer.date_of_birth"
              md-immediately
              :md-model-type="String"
            >
              <label>Date of Birth</label>
            </md-datepicker>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-switch v-model="customer.accepts_marketing"
              >Accepts Marketing</md-switch
            >
          </div>
          <div class="md-layout-item md-size-100">
            <md-button
              class="md-dense md-raised md-success mt-4"
              @click.prevent="updateCustomer"
              >Update</md-button
            >
          </div>
        </div>
      </form>
    </md-card-content>
  </md-card>
  <!-- </div> -->
</template>

<script>
import customerApi from "@/services/api/customer";
import optionsApi from "@/services/api/options";

export default {
  props: ["customer"],

  data() {
    return {
      countries: []
    };
  },

  methods: {
    updateCustomer() {
      customerApi
        .updateCustomer(this.customer)
        .then(response => {
          this.$notify({
            timeout: 2500,
            message: "The Customer has been updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(error => {});
    }
  },

  created() {
    optionsApi.countries().then(response => {
      this.countries = response.data;
    });
  }
};
</script>
